import React from "react";
import "./_loader.css";
export default function Loader() {
  return (
    <div className="container">
      <div className="loader"></div>
    </div>
  );
}
